(function() {
  var OPTION_NAME = 'Nombre de pattes';

  function getNameCount() {
    var radio = document.querySelector('input[name="' + OPTION_NAME + '"]:checked');
    if (radio) return parseInt(radio.value) || 0;
    return 0;
  }

  function updateFields() {
    var count = getNameCount();
    for (var i = 1; i <= 4; i++) {
      var field = document.getElementById('cosee-field-' + i);
      var input = document.getElementById('cosee-input-' + i);
      if (!field) continue;
      if (i <= count) {
        field.style.display = 'block';
        if (input) input.required = true;
      } else {
        field.style.display = 'none';
        if (input) { input.required = false; input.value = ''; }
      }
    }
    var err = document.getElementById('cosee-error-msg');
    if (err) err.style.display = 'none';
  }

  function getProperties() {
    var props = {};
    var count = getNameCount();
    for (var i = 1; i <= count; i++) {
      var input = document.getElementById('cosee-input-' + i);
      if (input && input.value.trim()) {
        props['Nom ' + i] = input.value.trim();
      }
    }
    return props;
  }

  function validateNames() {
    var count = getNameCount();
    var errMsg = document.getElementById('cosee-error-msg');
    for (var i = 1; i <= count; i++) {
      var input = document.getElementById('cosee-input-' + i);
      if (input && input.value.trim() === '') {
        input.style.borderColor = 'red';
        input.focus();
        if (errMsg) errMsg.style.display = 'block';
        input.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      }
      if (input) input.style.borderColor = '#d1d1d1';
    }
    if (errMsg) errMsg.style.display = 'none';
    return true;
  }

  function bindVariantEvents() {
    document.querySelectorAll('input[name="' + OPTION_NAME + '"]')
      .forEach(function(el) { el.addEventListener('change', updateFields); });

    document.addEventListener('click', function(e) {
      if (e.target.closest('.product-form, .product__info-container, [data-section]')) {
        setTimeout(updateFields, 150);
      }
    });
  }

  function bindAddToCart() {
    // Intercepte le clic sur le bouton ATC avant la soumission AJAX
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[name="add"], #ProductSubmitButton, .atc-button, [data-required-fields]');
      if (!btn) return;
      if (!validateNames()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }
      // Injecte les propriétés comme inputs cachés dans le form
      var form = btn.closest('form');
      if (!form) return;
      // Supprime les anciens inputs cosee
      form.querySelectorAll('[data-cosee-prop]').forEach(function(el) { el.remove(); });
      var props = getProperties();
      Object.keys(props).forEach(function(key) {
        var hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'properties[' + key + ']';
        hidden.value = props[key];
        hidden.setAttribute('data-cosee-prop', '1');
        form.appendChild(hidden);
      });
    }, true); // capture phase pour intercepter avant le thème
  }

  function init() {
    bindVariantEvents();
    bindAddToCart();
    updateFields();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
